// 登录
<template>
  <div class="home">
    <div class="login">
      <el-form :model="userInfo" :rules="rules" ref="userInfo" @keydown.enter.native="submitForm">
        <el-row :gutter="16">
            <el-col :span="24">
                <el-form-item prop="name">
                    <MzInput v-model.trim="userInfo.name" placeholder="请输入用户名"></MzInput>
                </el-form-item>
            </el-col>
            <el-col :span="24">
                <el-form-item prop="pwd">
                    <MzInput type="password" v-model.trim="userInfo.pwd" password placeholder="请输入密码"></MzInput>
                </el-form-item>
            </el-col>
            <el-col :span="24" class="submit">
                <el-button type="primary"  @click="submitForm">登 录</el-button>
            </el-col>
        </el-row>
    </el-form>
    </div>
  </div>
</template>

<script>

export default {
  name: '',
  data() {
    return {
      userInfo: {
          name: '',
          pwd: '',
      },
      rules: {
          name: [
              {required: true, message: '请输入用户名', trigger: 'blur'}
          ],
          pwd: [
              {required: true, message: '请输入登录密码', trigger: 'blur'}
          ],
      }
    };
  },
  mounted() {
  },
  methods: {
    submitForm(){
      this.$refs['userInfo'].validate((valid) => {
        if (valid) {
          if(this.userInfo.name === 'admin' && this.userInfo.pwd === 'lh@2025'){
            sessionStorage.setItem("username_2",JSON.stringify(this.userInfo))
            // this.$message.success("登录成功")
            if(this.$route.query.redirect){
              let redirect = this.$route.query.redirect
              this.$router.push(redirect)
            }else{
              this.$router.push('/admin')
            }
          }else{
            this.$message({
              message: '用户名或密码不正确',
              type: 'error',
              customClass: 'adminMsg'
            })
          }
        }
      })
    },
  },
};
</script>
<style lang="less" scoped>
@import '@/styles/index';
</style>